import user from './../user'

const manager = {
  path: '/manager',
  component: {
    template: '<router-view></router-view>'
  },
  children: [
    ...user
  ]
}

export default manager
